export default __webpack_public_path__ + "static/media/480_store05-it-web.bf0dbb68.png";